export default {
  'timeSelect.lastDay': 'Last Day',
  'timeSelect.last7Day': 'Last 7 Days',
  'timeSelect.lastMonth': 'Last Month',
  'timeSelect.thisMonth': 'This Month',
  'timeSelect.userDefined': 'Pick A Date Range',
  'timeSelect.SelectAll': 'Select All',
  'timeSelect.DeselectAll': 'Deselect All',
};
